import Vue from 'vue';
import i18n from "../../../i18n";

export default {
  async fetchNextMaxCode({ commit }) {
    return Vue.axios.get(Vue.$url("project/max-code"))
      .then((rsp) => { 
        commit('SET_NEXT_SEQ_CODE', rsp.data)
        return rsp.data;
      })
      
  },

  async fetchProjectStatuses({ commit }) {
    Vue.$log.debug('fetchh project statuses');
    return Vue.axios.get(Vue.$url("project/status-list"))
      .then((rsp) => commit('SET_PROJECT_STATUSES', rsp.data))
  },

  async fetchProjectById({ commit }, { id }) {
    Vue.$log.debug("fetchProjectById ", id);
    return Vue.axios.get(Vue.$url("project/" + id))
      .then((rsp) => commit("SET_PROJECT", rsp.data))
  },

  async fetchProjects({ commit }) {
    Vue.$log.debug('fetching projects ....');
    return Vue.axios
      .get(Vue.$url("project"))
      .then((rsp) => commit('SET_PROJECTS', rsp.data))
  },

  async fetchProjectNames({ commit }) {
    return Vue.axios.get(Vue.$url("project/names"))
      .then((rsp) =>  {
        commit('SET_PROJECT_NAMES', rsp.data)
        return rsp.data;
      })
  },

  async fetchProjectVesselNames({ commit }, pId) {
    Vue.$log.debug('fetching vessels for', pId);
    if (!pId) {
      return new Promise((resolve) => resolve(commit('SET_PROJECT_VESSELS', [])));
    }

    return Vue.axios.get(Vue.$url("project/" + pId + "/vessels"))
      .then((rsp) => commit('SET_PROJECT_VESSELS', rsp.data))
  },

  async createProject({ dispatch, commit }, payload) {
    return Vue.axios
      .post(Vue.$url("project"), payload)
      .then((rsp) => {
        commit('SET_PROJECT', rsp.data);
        commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'Project', 1: payload.projectName }), { root: true });

        dispatch('fetchProjects');
        dispatch('fetchProjectNames');
        return rsp.data;
      })
  },

  async createProjectVesselMapping({ dispatch }, { pId, vId }) {
    return Vue.axios
      .post(Vue.$url("project/" + pId + "/vessel/" + vId))
      .then((rsp) => {
        dispatch('fetchProjects');
        dispatch('m_passet/refreshProjectVessels', pId, { root: true });

        Vue.$log.debug('project', pId, 'vessel', vId, 'mapping saved under', rsp.data.id)
      })
  },

  async updateProject({ dispatch, commit }, payload) {
    return Vue.axios
      .put(Vue.$url("project/" + payload.id), payload)
      .then((rsp) => {
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Project', 1: payload.projectName }), { root: true });

        dispatch('fetchProjects');
        dispatch('fetchProjectNames');
        return rsp.data;
      })
  },

  async deleteProject({ dispatch, commit }, payload) {
    return Vue.axios.delete(Vue.$url("project/" + payload.id))
      .then((rsp) => {
        commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.projectName }), { root: true });

        dispatch('fetchProjects');
        return rsp.data;
      })
  },

  async deleteProjectVesselMapping({ dispatch }, { pId, vId }) {
    return Vue.axios
      .delete(Vue.$url("project/" + pId + "/vessel/" + vId))
      .then(() => {
        dispatch('fetchProjects');
        dispatch('m_passet/refreshProjectVessels', pId, { root: true });

        Vue.$log.debug('project', pId, 'vessel', vId, 'mapping removed')
      })
  },

}